import { render, staticRenderFns } from "./DepotEdit.vue?vue&type=template&id=bb73a3ec"
import script from "./DepotEdit.vue?vue&type=script&lang=js"
export * from "./DepotEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports